<template>
  <div class="profile_wrap">
    <div class="profile_detail pc_container">
     <div style="display: flex;justify-content: center;align-items: center; width: 100%;">
       <div>
        <div class="en_tit">{{about.en}}</div>
        <div class="profile_tit">{{about.title}}</div>
       </div>
     </div>
      <div class="picInfo">
        <div class="detail_text">
          <div class="detail_info">{{ about.desc }}</div>
          <div class="detail_more" @click="detail()">了解更多</div>
        </div>
        <div class="detail_img">
          <el-image :src="about.image" fit="contain" lazy :preview-src-list="[about.image]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    detail(){
      this.$router.push({
        path:'/company/index'
      })
    }
  },
  created() { }
}
</script>

<style lang="scss" scoped>
.text-one {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.profile_wrap {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  margin-bottom: 60px;
  text-align: center;
  background: #fff;
  min-height: 595px;
  .en_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 48px;
    color: #DCDCDC;
    text-align: left;
    text-transform: uppercase;
  }
  .profile_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    color: #000;
    margin-top:-15px;
    position: relative;
    text-align: left;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
    &::after {
      content: '';
      display: block;
      background: #000;
      width: 69px;
      height: 5px;
      background: #006DE8;
      margin-top: 15px;
      position: absolute;
      left: calc((100% - 69px)  / 2);
    }
  }
  .profile_detail {
    .picInfo{
      display: flex;
      justify-content: space-between;
      .detail_text{
        width: calc(100% - 620px);
        .detail_info {
          font-size: 16px;
          color: #474747;
          line-height: 26px;
          margin-top: 54px;
          text-align: left;
          text-indent: 2em;
        }
        .detail_more{
          width: 144px;
          height: 42px;
          background: #2A59AB;
          color: #fff;
          text-align: center;
          line-height: 42px;
          margin-top: 10px;
          cursor: pointer;
        }
      }
      .detail_img {
        width: 600px;
        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>